{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Applicazioni",
    "back": "Indietro",
    "campaigns": "Campagne",
    "dashboard": "Pannello di controllo",
    "devices": "Stazione locale S4",
    "dtwins": {
      "label": "Apparati",
      "manage": {
        "fleets": "Flotte",
        "label": "Gestisci",
        "devices": "Apparati"
      },
      "overview": {
        "label": "Panoramica",
        "map": "Mappa"
      }
    },
    "logout": "Disconnessione",
    "logs": "Registro",
    "overview": "Sintesi",
    "parameters": {
      "label": "Impostazioni",
      "platformMgt": "Gestione della piattaforma",
      "features": {
        "applicationManagement": "Gestione delle applicazioni",
        "firmwareManagement": "Firmware",
        "deviceConfiguration": "Configurazione degli apparati",
        "label": "Funzionalità",
        "licenseManagement": "Gestione della licenza",
        "interfaces": "Interfacce"
      },
      "monitoring": {
        "label": "Monitoraggio",
        "settings": "Configurazioni"
      }
    },
    "product": "Prodotto",
    "sector": {
      "label": "Rete",
      "placeholder": "Selezionare una rete"
    },
    "sectors": "Reti",
    "settings": "Configurazioni",
    "users": "Utenti"
  },
  "header": {
    "sectors": "Reti",
    "userMenu": {
      "title": "Menu dell’account",
      "logout": "Disconnessione",
      "userAccount": "Account utente",
      "about": "Informazioni",
      "connectMyMobileApp": "Connessione della mia applicazione mobile"
    },
    "admin": "Amministrazione",
    "delegation": {
      "select": {
        "label": "Seleziona un’organizzazione",
        "title": "Seleziona un’organizzazione"
      }
    }
  }
}
